export default __webpack_public_path__ + "static/media/Success.55c4edcb.png";